// History singleton for controlling a single instance of React Router
// from both inside <Router> and outside
// We need this so that we can route programmatically from ShopifyApp.Bar
// https://github.com/ReactTraining/react-router/blob/master/FAQ.md#how-do-i-access-the-history-object-outside-of-components
import { createBrowserHistory } from "history";
export default createBrowserHistory();
